// extracted by mini-css-extract-plugin
module.exports = {"hiddenHeaderContainer":"HiddenTrackHeader_hiddenHeaderContainer__2D5D8","hiddenTrackLabel":"HiddenTrackHeader_hiddenTrackLabel__1eP48"};